namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemExDTsRow {
        Id?: number;
        PmId?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PmType?: number;
        PmGroupId?: string;
        SkuCode?: string;
        PluCode?: string;
        SellUnitPrice1?: number;
        PluShortDesc?: string;
        StyleCode?: string;
        StyleName?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        SupplCode?: string;
        SupplName?: string;
    }

    export namespace Adv05ItemExDTsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.Adv05ItemExDTs';
        export const lookupKey = 'AdvPromo.Adv05ItemExDTs';

        export function getLookup(): Q.Lookup<Adv05ItemExDTsRow> {
            return Q.getLookup<Adv05ItemExDTsRow>('AdvPromo.Adv05ItemExDTs');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmId = "PmId",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PmType = "PmType",
            PmGroupId = "PmGroupId",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            SellUnitPrice1 = "SellUnitPrice1",
            PluShortDesc = "PluShortDesc",
            StyleCode = "StyleCode",
            StyleName = "StyleName",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            SupplCode = "SupplCode",
            SupplName = "SupplName"
        }
    }
}
